function formatName(name) {
	if (Object.prototype.toString.call(name) !== "[object String]") return name;
	var formattedName = name.toLowerCase();
	if (formattedName === "cd") {
		formattedName = "CD";
	} else if (formattedName === "ira") {
		formattedName = "IRA";
	} else if (formattedName === "creditcard") {
		formattedName = "Credit Card";
	}
	formattedName = formattedName.replace(/_/g, ' ');
	return formattedName;
}

export default formatName;